import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import { SITE } from "../data/site";

const CookiePolicy = () => (
  <>
    <Seo
      title="Cookie Policy | Studio Legale Avv. Manfredi Bruno, Palermo"
      description="Informativa sui cookie del sito dello Studio Legale Avv. Manfredi Bruno di Palermo: tipologie di cookie utilizzate e modalità di gestione delle preferenze."
      path="/cookie-policy"
    />
    <PageHero kicker="Documenti legali" title="Cookie Policy" breadcrumb="Cookie Policy" />

    <section className="bg-white py-14 sm:py-20">
      <div className="container-site legal-prose max-w-3xl" data-testid="cookie-content">
        <p>
          La presente Cookie Policy descrive l'utilizzo dei cookie e di tecnologie analoghe
          su questo sito web, in conformità al GDPR e alle linee guida del Garante per la
          protezione dei dati personali.
        </p>

        <h2>1. Cosa sono i cookie</h2>
        <p>
          I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo
          dell'utente, dove vengono memorizzati per essere ritrasmessi agli stessi siti
          alla visita successiva. Consentono funzionalità tecniche, preferenze e, se
          installati, rilevazioni statistiche.
        </p>

        <h2>2. Cookie utilizzati da questo sito</h2>
        <p>
          Questo sito utilizza esclusivamente <strong>cookie tecnici</strong>, necessari al
          corretto funzionamento delle pagine e alla sicurezza della navigazione. Tali
          cookie non richiedono il consenso dell'utente e non vengono utilizzati per
          finalità di profilazione o marketing.
        </p>
        <p>
          Il sito <strong>non installa cookie di profilazione propri</strong>. Sono
          presenti contenuti incorporati di terze parti (ad esempio la mappa di Google
          Maps nella pagina Contatti), che possono installare cookie secondo le rispettive
          informative, disponibili sui siti dei relativi fornitori.
        </p>

        <h2>3. Cookie analitici</h2>
        <p>
          Allo stato attuale il sito non utilizza strumenti di analisi statistica. In caso
          di futura attivazione (ad esempio Google Analytics), la presente informativa
          sarà aggiornata e sarà acquisito il consenso dell'utente ove richiesto dalla
          normativa.
        </p>

        <h2>4. Gestione delle preferenze</h2>
        <p>
          L'utente può gestire o eliminare i cookie attraverso le impostazioni del proprio
          browser. La disattivazione dei cookie tecnici può compromettere il corretto
          funzionamento del sito. Le procedure variano a seconda del browser utilizzato e
          sono disponibili nella sezione di supporto di ciascun browser.
        </p>

        <h2>5. Titolare del trattamento</h2>
        <p>
          Titolare del trattamento è l'<strong>Avv. Manfredi Bruno</strong>, con studio in{" "}
          {SITE.address} — email <strong>{SITE.email}</strong>. Per ogni chiarimento è
          possibile scrivere allo stesso indirizzo.
        </p>

        <p>Ultimo aggiornamento: luglio 2026.</p>
      </div>
    </section>
  </>
);

export default CookiePolicy;
